import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { OperatorForm } from "./operator.schema";
import { Input } from "@/src/components/ui/input";
import { CurrencySelect } from "@/src/components/CurrencySelect";

export function BankDetails() {
  return (
    <div className="grid gap-4 max-w-[1016px] grid-cols-[repeat(auto-fit,minmax(150px,328px))]">
      <h3 className="text-lg font-semibold col-span-full">Bank Transfer Details</h3>
      <FormField<OperatorForm, "transferDetails.recipientName">
        name="transferDetails.recipientName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Recipient name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField<OperatorForm, "transferDetails.accountNumber">
        name="transferDetails.accountNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel>BIC/SWIFT account number</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      {/** TODO: currency select */}
      <FormField<OperatorForm, "transferDetails.currencyCode">
        name="transferDetails.currencyCode"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Currency</FormLabel>
            <FormControl>
              <CurrencySelect onChange={field.onChange} value={field.value} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
